import React, { Fragment, useState, useEffect } from 'react';
import { closeMessageBanner } from '../Actions/MessageBanner.action';
import { useDispatch } from 'react-redux';
import SmdIcon
 from './SmdIcon';
const MessageBanner = ({
    banner
}) => {
    const [time, setTime] = useState(banner.countdownSeconds ?? -1);
    const [isOpen, setIsOpen] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        if (time > 0 ) {
            let timer = setInterval(() => {
                setTime((time) => {
                    if (time === 0) {
                    clearInterval(timer);
                    return 0;
                    } else return time - 1;
                });
            }, 1000);
        }
    }, []);

    const onBannerClose = () => {
        setIsOpen(false);
        dispatch(closeMessageBanner(banner.messageId));
    }
    
    const getMessage = () => {
        if (time >= 0) {
            let seconds = time;
            const days = Math.floor(seconds / (24 * 60 * 60));
            seconds %= 24 * 60 * 60;
            const hours = Math.floor(seconds / (60 * 60));
            seconds %= 60 * 60;
            const minutes = Math.floor(seconds / 60);
    
            let newMessage = '';
            if (days > 0) { newMessage += days + " d "; }
            if (hours > 0) { newMessage += hours + " h "; }

            return newMessage += minutes + " m " + banner.message;
        }
        return banner.message;
    }

    return (
        <Fragment>
            {isOpen && (
                <div className={`message-banner__item ${banner.alert?'message-banner__item--alert':''}`}>
                    <p className="message-banner__text" dangerouslySetInnerHTML={{__html: getMessage()}}></p>
                    <SmdIcon onClick={() => {onBannerClose()}} icon='close' cssClass='message-banner__close'></SmdIcon>
                </div>
            )}
        </Fragment>
    );
}

export default MessageBanner;
